module.exports = __webpack_public_path__ + "static/media/platform-desktop.43bdd343.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform-desktop.svg
// module id = 678
// module chunks = 0